import { render, staticRenderFns } from "./RollCard.vue?vue&type=template&id=02304238&scoped=true"
import script from "./RollCard.vue?vue&type=script&lang=js"
export * from "./RollCard.vue?vue&type=script&lang=js"
import style0 from "./RollCard.vue?vue&type=style&index=0&id=02304238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02304238",
  null
  
)

export default component.exports